/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStateConfig, ISymbolStates,
    StateReelSymbol
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export interface ITombstoneSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    attention:ISymbolStateConfig;
}

export class TombstoneReelSymbol extends StateReelSymbol {

    public shouldPlayWinText:{
        position:[number, number],
        betWayWinData:IBetWayWinData
    };
    public winTextPlayed:boolean = false;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }
}